<script setup lang="ts">
import StatementItemisedList from '@/components/dashboard/statements/StatementItemisedList.vue'
import type { DonorDonation, DonorFinancialYear } from '@/types/donorFinancialYear'

defineProps<{
  financialYear: DonorFinancialYear
  manualDonations: DonorDonation[]
}>()

const emit = defineEmits<{
  close: []
}>()
</script>

<template>
  <div class="sa-stmt-detail-panel">
    <StatementItemisedList
      :financial-year="financialYear"
      :manual-donations="manualDonations"
    />
    <div class="sa-stmt-detail-panel__footer">
      <button
        type="button"
        class="sa-stmt-detail-panel__hide-link"
        @click="emit('close')"
      >
        {{ $t('Dashboard.Statements.HideDetail') }}
      </button>
    </div>
  </div>
</template>
